module.exports = __webpack_public_path__ + "static/media/map.456ccd40.svg";